import React from 'react';
import styled from 'styled-components';
import { ImpContainer } from '../..';
import { colors } from '../../DesignSystem/colors';
import { getElevationFromNumber } from '../../DesignSystem/elevation';
const SURFACE_BORDER_RADIUS = '12px';
const Container = styled(ImpContainer) `
  ${(props) => {
    if (getElevationFromNumber(props.elevation)) {
        return `box-shadow: ${getElevationFromNumber(props.elevation)};`;
    }
}}
`;
export default function ImpSurface({ dataTestId = 'surface', surfaceColor = colors.surface.surfaceHigh, fluid, children, hasBorderRadius, elevation, ...args }) {
    return (React.createElement(Container, { dataTestId: dataTestId, backgroundColor: surfaceColor, borderRadius: hasBorderRadius ? SURFACE_BORDER_RADIUS : undefined, elevation: elevation, ...(fluid && { height: '100%', width: '100%' }), ...args }, children));
}
//# sourceMappingURL=ImpSurface.js.map